const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const SUBSCRIPTIONS = {
    SUBSCRIBE: `${API_BASE_URL}/subscriptions/subscribe/`,
    CHECK: (id) => `${API_BASE_URL}/subscriptions/check-subscription/${id}/`,
    USER_SUBSCRIPTIONS: `${API_BASE_URL}/subscriptions/fetch-subscriptions/`,
};

export default SUBSCRIPTIONS;